import { useEffect, useState } from 'react';

export default function useChangeTheme() {

    const [isLight, setIsLight] = useState(true)

    useEffect(() => {
        if(localStorage.getItem('theme')) {
            setIsLight(parseInt(localStorage.getItem('theme')))
        }
    }, [])

    useEffect(() => {
        if(isLight) {
            document.body.style.setProperty('--body-color', '#eeeeee');
            document.body.style.setProperty('--card-color', 'white');
            document.body.style.setProperty('--third-color', '#eeeeee');
            localStorage.setItem('theme', '1');
        } else {
            document.body.style.setProperty('--body-color', '#505050');
            document.body.style.setProperty('--card-color', '#858585');
            document.body.style.setProperty('--third-color', '#aaaaaa')
            localStorage.setItem('theme', '0');
        }
    }, [isLight]);

    return [isLight, setIsLight];
}